// Hand-rolled relative timestamp formatter for the chat sidebar (UI-02).
// Per Phase 16 UI-SPEC and CONTEXT.md: no external library — date-fns/dayjs
// are not in package.json and `moment` is intentionally avoided here.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Returns a relative timestamp string for the given date.
 *  < 60s        -> "just now"
 *  1-59 min     -> "{N}m ago"
 *  1-23 hours   -> "{N}h ago"
 *  1-6 days     -> "{N}d ago"
 *  7+ days      -> "{Mon} {DD}"  (e.g. "Apr 21")
 *
 * Accepts an ISO 8601 string or a Date object. Returns "" for invalid input.
 */
export default function formatRelative(date) {
    if (date == null) return '';
    const then = (date instanceof Date) ? date.getTime() : new Date(date).getTime();
    if (isNaN(then)) return '';

    const now = Date.now();
    const diffMs = now - then;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr  = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr  / 24);

    if (diffSec < 60)  return 'just now';
    if (diffMin < 60)  return diffMin + 'm ago';
    if (diffHr  < 24)  return diffHr  + 'h ago';
    if (diffDay <= 6)  return diffDay + 'd ago';

    const d = (date instanceof Date) ? date : new Date(date);
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
}
